import { render, staticRenderFns } from "./WebixSlider.vue?vue&type=template&id=8918c94a&scoped=true&"
import script from "./WebixSlider.vue?vue&type=script&lang=js&"
export * from "./WebixSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8918c94a",
  null
  
)

export default component.exports